
<p [title]="givenName() + ' ' + familyName()">{{ initials() }}</p>
